import { useGetSelectedOrganisation } from "./useGetSelectedOrganisation";

export function useCurrentOrgTimezone() {
  const currentOrg = useGetSelectedOrganisation();

  if (currentOrg) {
    return currentOrg.validatedTimezone;
  }

  return `UTC`;
}
